const routes = [

  {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
    path: '',
    component: () => import('@/layouts/home-page/HomePage.vue'),
    children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
            path: '/',
            name: 'Home',
            component: () => import('../views/frontend/Home.vue'),
            meta: {
              roles: ['user','admin']
            },
        },
        {
          path: '/event/:slug',
          name: 'Event',
          component: () => import('../views/frontend/Event.vue'),
          meta: {
            roles: ['user']
          },
        },
        {
          path: '/ghost/event/:slug',
          name: 'Event',
          component: () => import('../views/frontend/GhostEvent.vue'),
          meta: {
            roles: ['admin']
          },
        }
    ],
  },

    //=============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
  {
    path: '',
    component: () => import('@/layouts/full-page/FullPage.vue'),
    children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
            path: '/login',
            name: 'user_login',
            component: () => import('@/views/frontend/auth/Login.vue')
        },
        {
          path: '/rsvp/:uuid',
          name: 'rsvp',
          component: () => import('@/views/pages/Rsvp.vue')
      },
      {
        path: '/rsvpi',
        name: 'rsvp',
        component: () => import('@/views/pages/RsvpIdentifire.vue')
      },
      {
        path: '/privacy',
        name: 'privacy',
        component: () => import('@/views/pages/Privacy.vue')
      },
      {
        path: '/user/campaign/unsubscribe',
        name: 'user.campaign.unsubscribe',
        component: () => import('@/views/pages/user-campaign-unsubscribe.vue')
      }
    ],
  },
]
  
  export default routes